var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImcImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.84,
    height: 18.84,
    viewBox: "0 0 18.84 18.84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_4087669",
    "data-name": 4087669,
    d: "M14.424,18.84H4.416A4.421,4.421,0,0,1,0,14.424V4.416A4.421,4.421,0,0,1,4.416,0H14.424A4.421,4.421,0,0,1,18.84,4.416V14.424A4.421,4.421,0,0,1,14.424,18.84ZM4.416,1.472A2.947,2.947,0,0,0,1.472,4.416V14.424a2.947,2.947,0,0,0,2.944,2.944H14.424a2.947,2.947,0,0,0,2.944-2.944V4.416a2.947,2.947,0,0,0-2.944-2.944ZM15.9,6.7a.736.736,0,0,1-.736.736H13.377a.738.738,0,0,0-.563.262,4.45,4.45,0,0,1-6.788,0,.738.738,0,0,0-.563-.262H3.68a.736.736,0,0,1,0-1.472H5.463a2.208,2.208,0,0,1,1.684.78,2.973,2.973,0,0,0,4.545,0,2.208,2.208,0,0,1,1.684-.78H15.16A.736.736,0,0,1,15.9,6.7ZM9.009,6.2A.736.736,0,0,0,10.03,6l1.288-1.913A.736.736,0,0,0,10.1,3.269L8.809,5.182A.736.736,0,0,0,9.009,6.2Z",
    fill: "#394f65"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImcImage);
export default __webpack_public_path__ + "static/media/imc_image.91eb979f407b7b6637e6fd1b36232cb1.svg";
export { ForwardRef as ReactComponent };